import {
} from '../mutation-types'
import superagent from 'superagent'
import { RequestCommonResponse } from '../actions'
const baseUrl = 'https://wx.dudubashi.com' // 替换为基本URL

const state = {
}

const mutations = {
}

const actions = {
  // params: line_id, from_site_id, to_site_id, is_search
  getLineDetail ({ commit, state, rootState }, params) {
    return new Promise(function (resolve, reject) {
      superagent
      .post(baseUrl + '/index.php/line/info/get_line_info')
      .send(params)
      .type('form')
      .end(function (err, res) {
        if (err) {
          throw err
        } else {
          res = JSON.parse(res.text)
          RequestCommonResponse({
            'rootState': rootState,
            'res': res,
            successCallback: function (res) {
              resolve(res)
            },
            failCallback: function (res) {
              reject(res)
            }
          })
        }
      })
    })
    // commit('UPDATE_LOADING', val)
  }
}

export default {
  namespaced: true,
  actions,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/lineDetail.js